import { Icon, Text, Loader, } from "@bracket/ui/components";
import { InteractiveElement, } from "@bracket/ui/nodes";
import { getTheme, } from "@bracket/ui/themes";
import type { IconName, TypeVariant, TRBL, } from "../../../types";
import styled from "styled-components";



export declare type ButtonNextProps = {
	label: string;
	icon?: IconName;
	iconPosition?: TRBL;
	disabled?: boolean;
	loading?: boolean;
	foreground?: boolean;
	outline?: boolean;
	textVariant?: TypeVariant;
	onClick?: () => void|Promise<void>;
};



export const ButtonNext = ({
	label,
	icon,
	iconPosition = "left",
	foreground,
	outline,
	disabled = false,
	loading = false,
	textVariant = "p",
	onClick = () => {},
}: ButtonNextProps) => {

	const classes = [foreground ? "foreground" : null, outline ? "outline" : null, disabled ? "disabled" : null].filter(Boolean).join(" ");
	
	// Get the line height from the theme based on textVariant
	const theme = getTheme();
	const variantStyle = theme.typeface[textVariant || "p"];
	const iconHeight = variantStyle?.lineHeight || "20px";

	return (
		<ButtonBase className={classes} $iconPosition={iconPosition} onClick={onClick}>
			{ icon && !loading && ["top", "left"].includes(iconPosition) && <Icon icon={icon} height={iconHeight} /> }
			{ label && !loading && <Text variant={textVariant} color="inherit" weight="inherit">{label}</Text> }
			{ icon && !loading && ["bottom", "right"].includes(iconPosition) && <Icon icon={icon} height={iconHeight} /> }
			{ loading && <Loader type="ellipsis" height={iconHeight} center small /> }
		</ButtonBase>
	)

}


const ButtonBase = styled(InteractiveElement)<{ $iconPosition: TRBL; }>`
	
	flex-direction: ${({ $iconPosition }) => ["top", "bottom"].includes($iconPosition) ? "column" : "row" };
	border-radius: 8px;
	padding: 12px;
	font-weight: 500;
	gap: 4px;

	background: ${getTheme().primary};
	color: ${getTheme().primary_on};

	&.foreground {
		background: ${getTheme().debug};
		color: ${getTheme().debug_on};
	}

	&.outline {
		border: ${getTheme().outline};
	}

	&:hover {
		background: ${getTheme().background_on};
		&.foreground {
			background: ${getTheme().debug};
		}
	}

	&.disabled {
		cursor: not-allowed;
		background: ${() => getTheme().surface_container_low};
		color: ${() => getTheme().surface_variant_on};
		&.outline {
			border: ${() => getTheme().outline_variant};
		}
	}

	transition: all 0.3s ease;
`;
